import { createSlice } from "@reduxjs/toolkit";
import {
  readLocalStorageJSON,
  writeLocalStorageJSON,
} from "../utils/safeLocalStorage";

const initialState = {
  selectedUser: readLocalStorageJSON("selectedUser", null),
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setSelectedUser: (state, action) => {
      state.selectedUser = action.payload ?? null;
      writeLocalStorageJSON("selectedUser", state.selectedUser);
    },
    clearUser: (state) => {
      state.selectedUser = null;
      localStorage.removeItem("selectedUser");
    },
  },
});

export const { setSelectedUser, clearUser } = userSlice.actions;

export default userSlice.reducer;
